export const COMPANY_NAME = 'RESIDENTS ASSOCIATION FRIENDSHIP VILLAGE OF DUBLIN';
export const COMPANY_SHORT = 'Friendship Village Residents';
export const COMPANY_ADDRESS_FULL = '6000 RIVERSIDE DR APT A450, DUBLIN, OH 43017-5464';
export const COMPANY_LOCATION = 'Dublin, Ohio';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=6000%20RIVERSIDE%20DR%20APT%20A450%2C%20DUBLIN%2C%20OH%2043017-5464';
export const HERO_IMAGE_URL =
  'https://images.unsplash.com/photo-1518156677180-95a2893f3e9f?auto=format&fit=crop&w=1600&q=80';
export const HERO_IMAGE_SOURCE_URL = 'https://unsplash.com/photos/Z9-EYlIxFLM';

export const PROFILE_FACTS = [
  { label: 'Role', value: 'Residents-led community association' },
  { label: 'Community', value: 'Friendship Village of Dublin' },
  { label: 'Location', value: COMPANY_LOCATION },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Address', value: COMPANY_ADDRESS_FULL },
];

export const COMMUNITY_FOCUS = [
  {
    number: '01',
    title: 'Neighborly Voice',
    body: 'A residents-led association presented as a public, member-supported voice for everyday life at Friendship Village of Dublin.',
  },
  {
    number: '02',
    title: 'Friendship & Belonging',
    body: 'The page reflects the spirit of a friendship village: warm color, generous spacing, and language centered on people, hospitality, and shared porches.',
  },
  {
    number: '03',
    title: 'Source-Backed Profile Only',
    body: 'Only the publicly supplied name, city, and mailing address are shown. Private registry and tax identifiers are intentionally kept off this page.',
  },
];
